/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import cloneDeep from 'lodash/cloneDeep';

import Docxtemplater from 'docxtemplater';
import JSZipUtils from 'jszip-utils';
import JSZip from 'jszip';

import { compareForm, getFormCreatedMetadata, sendFormFieldsMetadata } from '../../../shared/mixpanel';
import { autocompleteQuotaStatus } from '../reducers/fieldSettings';
import autosave from '../builder_utils/localStorage';
import uploader from '../../../shared/uploader';
import { inventoryControls } from './element';
import { doSaveCtrl } from './editbar';
import win from '../../../shared/win';

import {
  convertToStorableClosingPages,
  generateBuilderForm,
  getImageDimensions,
  pageReorderControl,
  textFieldsWithType,
  ammendBuilderForm,
  planSupportField,
  formHasControls,
  paymentFields,
  checkWideForm,
  formAmendForm,
  dataURItoBlob,
  ctrlDefaults,
  ControlType,
  prepareForm,
  ctrlErrors,
  InputType,
  elements,
} from '../../../shared/form-lib';

import {
  updateCustomDocumentsProcessKeys,
  updateCustomDocumentTemplates,
  setCustomDocumentTemplates,
  disablePaymentUserSpecify,
  doShowQuotaExceededModal,
  indicateFormDeactivation,
  setIsBuilderFormUpdated,
  doShowFormControlsModal,
  setRedirectToCustomise,
  setupSavedLocalForm,
  doSaveUserOptions,
  showBuilderError,
  fetchFormFailure,
  fetchFormSuccess,
  fetchPDFSuccess,
  showFieldError,
  fetchFormStart,
  doSetUpNewForm,
  updateAutoSave,
  setUserQuota,
  savingForm,
  clearForm,
} from '../reducers/builder';

import {
  paymentCredentialMissingModal,
  checkPaymentCredentials,
  showClearPremiumModal,
  doShowFormNameModal,
  updateCredential,
  disableHandler,
  showFormError,
  externalSave,
  checkUserVm,
  updatePlan,
  saveAction,
} from '../reducers/form-validations';

import {
  hasLiteralNullOrUndefined,
  logErrorToCloudReporting,
  hasDuplicateString,
  isInvalidEditorMsg,
  generateFileInfo,
  htmlToPlainText,
  urlTestPattern,
  hasEmptyString,
  newIdentifier,
  getPDFForm,
  apiCommon,
  fplsFetch,
  isOwner,
  hasPerm,
  perms,
} from '../../../shared/utils';
import uiUploader from '../../../shared/uploader';

const {
  PLAN: { has_document_merge = false, custom_document_limit = 0, name: plan_name = '', is_trial = false } = {},
  location: { protocol = '', hostname = '', port = '' } = {},
  ACTIVE_TEAM = null,
  USER_ID = '',
} = win || {};

export const isActiveTeamOwner = isOwner(ACTIVE_TEAM || {});

export const manageDocxTemplatePermitted = isActiveTeamOwner || hasPerm(perms.MANAGE_DOCUMENT_TEMPLATES, ACTIVE_TEAM);

const generateFileName = (title) => {
  let newName = title.slice(0, 20);
  newName = newName.replace(/[\W_]+/g, '-').toLowerCase();
  return newName;
};

const loadFile = (url, callback) => {
  JSZipUtils.getBinaryContent(url, callback);
};

const transformBuilderPages = (builderForm) => {
  const newBuilderForm = cloneDeep(builderForm);

  newBuilderForm.pages = builderForm.pages.map((page) => {
    const controls = Object.values(page);
    return {
      controls,
    };
  });

  return newBuilderForm;
};

export const getQuestionInternalIdPair = () => (_, getState) => {
  const { builderForm } = getState().builder.present;
  const { pageIds } = builderForm;

  if (!pageIds.length) return;
  const formDefinition = transformBuilderPages(builderForm);

  const fieldsToRemove = ['add_row', 'media_image', 'embed_field'];
  const fieldsWithTextAsValue = ['description', 'media_header'];
  const questionInternalIdPair = [];

  const getQuestions = (ctrl) => {
    const questions = {
      label: !fieldsWithTextAsValue.includes(ctrl.type) ? ctrl.props.label || ctrl.props.text : '',
      prependedText: ctrl.props.prepended_text || '',
      appendedText: ctrl.props.appended_text || '',
      helpText: ctrl.props.subtext || '',
    };

    const questionsWithValue = Object.values(questions).filter(Boolean);
    return questionsWithValue.length ? questionsWithValue.join('\n') : '';
  };

  formDefinition.pages.forEach((page) => {
    page.controls.forEach((ctrl) => {
      if (ctrl.type === 'table_field') {
        // Add table label if available before appending column fields
        const question = getQuestions(ctrl);
        if (question) questionInternalIdPair.push({ question });

        ctrl.props.column_headers.forEach((header, i) => {
          const customInternalId = `${ctrl.internal_id}_${i}`;
          questionInternalIdPair.push({
            question: header,
            answer: `{{ answer_${customInternalId} }}`,
          });
        });
      } else if (!fieldsToRemove.includes(ctrl.type)) {
        const getAnswer = () =>
          fieldsWithTextAsValue.includes(ctrl.type) ? ctrl.props.text : `{{ answer_${ctrl.internal_id} }}`;

        const entry = { answer: getAnswer() };
        const question = getQuestions(ctrl);

        if (question) entry.question = question;
        questionInternalIdPair.push(entry);
      }
    });
  });

  questionInternalIdPair.push({
    question: 'Submission timestamp',
    answer: '{{ submission_timestamp }}',
  });

  return questionInternalIdPair;
};

export const fetchCustomDocumentTemplates = (formId) => async (dispatch) => {
  try {
    const { headers, templates } = await fplsFetch({ url: `/api/v2/user/${formId}/custom_templates` });

    let autorespTemplate = '';
    let notifTemplate = '';

    for (const template of templates) {
      if (template.template_type === 'notification') {
        notifTemplate = template.template_key;
      } else if (template.template_type === 'autoresponder') {
        autorespTemplate = template.template_key;
      }
    }

    const payload = {
      columns: headers,
      autorespTemplate,
      notifTemplate,
      templates,
      headers,
    };

    dispatch(setCustomDocumentTemplates(payload));
  } catch (error) {
    console.error('Error loading custom documents. Details:', error);

    const payload = {
      error: 'Error loading custom documents. Details:',
      isFetching: false,
      error,
    };

    dispatch(setCustomDocumentTemplates(payload));
  }
};

export const canUploadCustomTemplates = () => (_, getState) => {
  const {
    customDocuments: { templates },
  } = getState().builder.present;

  const templateCount = templates.length;

  if (!has_document_merge) {
    return {
      message: 'Feature available on the Platinum and Enterprise plan only.',
      allowed: false,
    };
  }

  const isLimitReached = (is_trial && templateCount >= 3) || templateCount >= custom_document_limit;

  if (isLimitReached) {
    const baseMessage = `You have reached the upload limit (${custom_document_limit}) on your plan.`;
    const actionMessage = is_trial
      ? 'Upgrade to the Platinum plan to upload more document templates.'
      : 'Contact support to continue uploading document templates.';

    return {
      message: `${baseMessage} ${actionMessage}`,
      allowed: false,
    };
  }

  return { allowed: true, message: '' };
};

export const generateCustomDocumentTemplate = () => (dispatch, getState) => {
  const { builderForm } = getState().builder.present;

  const questionInternalIdPair = dispatch(getQuestionInternalIdPair());

  loadFile('/static/documents/single-response-template.docx', (error, content) => {
    if (error) throw error;

    const zip = new JSZip(content);
    const doc = new Docxtemplater().loadZip(zip);
    doc.setOptions({ paragraphLoop: true });
    doc.setData({
      form_title: '{{ form_title }}',
      response: questionInternalIdPair,
    });

    try {
      doc.render();
    } catch (error) {
      const e = {
        message: error.message,
        name: error.name,
        stack: error.stack,
        properties: error.properties,
      };
      console.error(JSON.stringify({ error: e }));
      throw error;
    }

    const out = doc.getZip().generate({
      type: 'blob',
      mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });

    const link = document.createElement('a');
    const url = URL.createObjectURL(out);
    link.href = url;
    link.download = `sample-custom-document-template-${generateFileName(builderForm.name)}.docx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  });
};

export const doDocUpload = (file) => (dispatch, getState) => {
  const {
    form: { id: formId },
  } = getState().builder.present;

  const uploader = new uiUploader();
  const maxFileSize = 1024 * 1024 * 10;
  const docxmime = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  // Start the upload state
  dispatch(
    setCustomDocumentTemplates({
      isUploadingTemplate: true,
      templateUploadError: '',
    })
  );

  // Validate file type and size
  if (!file || file.type !== docxmime) {
    dispatch(
      setCustomDocumentTemplates({
        isUploadingTemplate: false,
        templateUploadError: 'Please upload a docx file',
      })
    );
    return;
  }

  // Validate maximum size
  if (file.size > maxFileSize) {
    dispatch(
      setCustomDocumentTemplates({
        isUploadingTemplate: false,
        templateUploadError: 'Unable to upload file. Maximum file size is 10MB. Please check and try and again.',
      })
    );
    return;
  }

  const reader = new FileReader();
  reader.readAsDataURL(file);

  reader.onload = () => {
    const docxDataURL = reader.result;
    loadFile(docxDataURL, async (error, content) => {
      if (error) throw error;

      const zip = new JSZip(content);
      const doc = new Docxtemplater().loadZip(zip);
      const text = doc.getFullText();

      // the regex is checking for
      // <{{><0++ space/s><word/s><space/s><word/s><0++ space/s><optional }}>
      const invalidContentRegex = /\{\{\s*[A-Za-z0-9_]+\s+[A-Za-z0-9_]+\s*(\}\})?/g;

      const invalidContents = text.match(invalidContentRegex);

      if (invalidContents && invalidContents.length > 0) {
        dispatch(
          setCustomDocumentTemplates({
            isUploadingTemplate: false,
            templateUploadError:
              invalidContents.length === 1 ? 'Docx file has an invalid tag' : 'Docx file has invalid tags',
          })
        );

        return;
      }

      uploader.addFiles([file]);

      try {
        const response = await fplsFetch({ url: '/api/v2/user/custom-template-upload' });

        if (response) {
          uploader.startUpload({
            headers: { 'Content-Type': docxmime },
            url: response.upload_url,
            concurrency: 1,
            method: 'PUT',
            type: 'File',
            onProgress: (stream) => {
              dispatch(
                setCustomDocumentTemplates({
                  templateUploadProgress: {
                    loaded: stream.loaded,
                    humanSize: stream.humanSize,
                  },
                })
              );
            },
            onCompleted: async () => {
              const fileInfo = generateFileInfo(response.blob_name, file);

              try {
                const details = await fplsFetch({
                  data: { file_field_id: '', file_info: fileInfo },
                  url: '/api/v2/user/custom-template-upload',
                  // removeToken: true,
                  method: 'POST',
                });

                const { path: templateUrl, filename: fileName } = details;

                const newTemplate = await fplsFetch({
                  data: { fileUrl: templateUrl, fileName: fileName },
                  url: `/api/v2/user/${formId}/custom_templates`,
                  // removeToken: true,
                  method: 'POST',
                });

                if (newTemplate && !newTemplate.error) {
                  toast.success('Template upload successful!');

                  dispatch(
                    setCustomDocumentTemplates({
                      isUploadingTemplate: false,
                      templateUploadError: '',
                      templateUploadProgress: {
                        loaded: 0,
                        humanSize: 0,
                      },
                    })
                  );

                  dispatch(
                    updateCustomDocumentTemplates({
                      values: {
                        newTemplate,
                      },
                    })
                  );
                }
              } catch (error) {
                console.error('Error while uploading docx template: ', error);

                dispatch(
                  setCustomDocumentTemplates({
                    isUploadingTemplate: false,
                    templateUploadError:
                      'An error while uploading docx template. ' +
                      'Please refresh & try again. You may also send an email ' +
                      'to support@formpl.us if this persists.',
                    templateUploadProgress: {
                      loaded: 0,
                      humanSize: 0,
                    },
                  })
                );
              }
            },
          });
        }
      } catch (error) {
        console.error('notificationTemplateUrl.get error', error);

        dispatch(
          setCustomDocumentTemplates({
            isUploadingTemplate: false,
            templateUploadError: 'Upload failed. Please try again or contact support.',
          })
        );
      }
    });
  };
};

export const doDeleteDocumentTemplate = (temp) => async (dispatch, getState) => {
  const {
    customDocuments: { selectedTemplate },
    form: { id: formId },
  } = getState().builder.present;

  const deletedTemplateKey = temp ? temp.template_key : selectedTemplate.template_key;

  const handleProcessKeyUpdate = (type) => {
    dispatch(
      updateCustomDocumentsProcessKeys({
        values: { type, deletedTemplateKey },
      })
    );
  };

  handleProcessKeyUpdate('add');

  try {
    const response = await fplsFetch({
      url: `/api/v2/user/${formId}/custom_template/${deletedTemplateKey}`,
      method: 'DELETE',
    });

    if (response.error) {
      handleProcessKeyUpdate('delete');
      toast.error(response.error);
      return;
    }

    if (response.status === 'done') {
      toast.success('Template deleted successfully!');
      handleProcessKeyUpdate('delete');
      dispatch(
        updateCustomDocumentTemplates({
          values: { deletedTemplateKey },
        })
      );
    }
  } catch (error) {
    console.error('Error deleting template. Details: ', error);
    handleProcessKeyUpdate('delete');
    toast.error(error);
  }
};

export const quotaHandler = (response) => (dispatch) => {
  const formsLeft = response.forms_left === 'inf' ? Infinity : parseInt(response.forms_left, 10);

  if (formsLeft > 0) return false;

  const errorText = 'You have used up your monthly form quota.';
  const metadata = {
    plan_name,
  };
  window.Intercom('trackEvent', 'exceeded-form_quota', metadata);
  dispatch(showBuilderError(errorText));
  return true;
};

export const checkAddresAutoCompletionQuota = () => async (dispatch) => {
  try {
    const response = await fplsFetch({ url: '/api/v2/user/quota' });
    dispatch(autocompleteQuotaStatus(response.address_autocompletion));
  } catch (error) {
    console.error('Error while loading user quota info. Details:', error);
  }
};

export const checkQuotas = () => async (dispatch) => {
  let exceeded = true;

  try {
    const response = await fplsFetch({ url: '/api/v2/user/quota' });
    exceeded = dispatch(quotaHandler(response));

    dispatch(
      setUserQuota({
        submissionsLeft: response.submissions_left === 'inf' ? Infinity : parseInt(response.submissions_left, 10),
        maxFormView: response.max_form_view === 'inf' ? Infinity : parseInt(response.max_form_view, 10),
        formsLeft: response.forms_left === 'inf' ? Infinity : parseInt(response.forms_left, 10),
        submissionsUsed: parseInt(response.submissions_used, 10),
        formViewsUsed: parseInt(response.forms_views_used, 10),
        membersCount: parseInt(response.members_count, 10),
        membersMax: parseInt(response.members_max, 10),
        formsUsed: parseInt(response.forms_used, 10),
        storageLimit: response.storage_limit,
        storageUsed: response.storage_used
      })
    );
  } catch (error) {
    const errorText = "You don't have permission to create form ";
    dispatch(showBuilderError(errorText));
    console.error('Error while loading user info. Details:', error);
  }

  return exceeded;
};

const uploadPDFImgToServer = async (dataUrl, name) => {
  const uploaderInstance = new uploader();
  const file = dataURItoBlob(dataUrl);
  const contentType = file.type;
  file.name = name;
  const promise = new Promise(async function (resolve) {
    const response = await fplsFetch({ url: `/attachment/images?mimetype=${contentType}` });
    if (response.error) {
      console.error('uploadPDFImgToServer.get error: ', response.error);
      resolve('');
    } else {
      const dim = await getImageDimensions(dataUrl);
      const imgData = {
        width: dim.w,
        height: dim.h,
      };
      const { blob_name, upload_url } = response;
      uploaderInstance.addFiles([file]);
      uploaderInstance.startUpload({
        url: upload_url,
        headers: { 'Content-Type': contentType },
        method: 'PUT',
        concurrency: 1,
        type: 'File',
        data: imgData,
        async onCompleted() {
          const fileInfo = generateFileInfo(blob_name, file);
          Object.assign(fileInfo, imgData);
          const validationResp = await fplsFetch({
            url: '/attachment/images',
            data: { file_info: fileInfo },
            method: 'POST',
          });
          if (validationResp.error) {
            console.error('uploadPDFImgToServer.validate error: ', validationResp.error);
            resolve('');
          } else {
            try {
              localStorage.setItem(name, validationResp.url);
            } catch (err) {
              console.error('Saving PDF image name Localstorage Error', err);
              resolve('');
            }
            resolve(validationResp.url);
          }
        },
        onError() {
          console.error('uploadPDFImgToServer.uploading error');
          resolve('');
        },
      });
    }
  });
  return promise;
};

export const fetchUserOptions = () => async (dispatch) => {
  try {
    const response = await fplsFetch({ url: `/api/v2/user/options` });
    dispatch(doSaveUserOptions(response));
  } catch (error) {
    console.error('Error fetching user options:', error);
  }
};

export const updateOnboardedStatus = (status) => async (_, getState) => {
  const {
    present: { form },
  } = getState().builder;

  const msg = 'Encountered error while updating user onboarding status';

  try {
    const response = await fplsFetch({
      url: '/api/v2/user/options',
      method: 'PUT',
      data: {
        onboarded_v2: true,
      },
    });

    if (response.error) {
      console.error(msg);
    } else {
      const formId = form?.id || '_NEW_';
      const metadata = {
        form_url: `${protocol}//${hostname}:${port}/form/${formId}`,
        form_id: formId,
        plan_name,
      };
      window.Intercom('trackEvent', status ? 'watched-builder-v2-tour' : 'skipped-builder-v2-tour', metadata);
    }
  } catch (error) {
    console.error(msg);
  }
};

export const fetchTrueForm = (formId) => async (dispatch) => {
  try {
    const trueForm = await fplsFetch({ url: `/api/v2/user/form/${formId}` });

    if (trueForm?.error) {
      if (trueForm?.status === '403' && trueForm.error.includes('form is inactive')) {
        dispatch(indicateFormDeactivation(true));
      }

      console.error('Error fetching form');
      return false;
    }

    return trueForm;
  } catch (error) {
    console.error('Error fetching form:', error);
    return false;
  }
};

export const doFetchSavedForm = (json, isAutosave, formId) => {
  return (dispatch) => {
    if (json.error) {
      const notFoundMsg = 'Requested form could not be found.';
      const failedGetMsg =
        'An error has occurred when attempting to ' +
        'retrieve this form. Please refresh & try again. You may also send ' +
        'an email to support@formpl.us if this persists';
      const error = json.error && json.status === 404 ? notFoundMsg : failedGetMsg;
      dispatch(fetchFormFailure({ error, loading: false }));
      console.error('Fetch Form Error', error);
      logErrorToCloudReporting(error);
      toast.error(error);
    } else if (!isAutosave && prepareForm(json.definition)) {
      dispatch(
        fetchFormSuccess({
          form: formAmendForm(json),
          isSavedForm: true,
          loading: false,
        })
      );

      const metadata = {
        form_url: `${protocol}//${hostname}:${port}/form/${formId}`,
        form_id: formId,
        plan_name,
      };

      window.Intercom('trackEvent', 'editing-form', metadata);
    } else {
      dispatch(setupSavedLocalForm(json));
    }
  };
};

export const doFetchTemplateForm = (json, templateId, isAutosave) => {
  return async (dispatch) => {
    if (isAutosave) dispatch(updateAutoSave({ status: true, autoSavedResponse: json }));
    if (json.error) {
      const notFoundMsg = 'Requested form could not be found.';
      const failedGetMsg = `An error has occurred when attempting to 
        retrieve this form. Please refresh & try again. You may also send 
        an email to support@formpl.us if this persists`;
      const error = json.error && json.status === 404 ? notFoundMsg : failedGetMsg;
      dispatch(fetchFormFailure({ error, loading: false }));
      console.error('Fetch Form Error', error);
      logErrorToCloudReporting(error);
      toast.error(error);
    } else if (prepareForm(json.definition, 2)) {
      dispatch(
        fetchFormSuccess({
          form: formAmendForm(json),
          isTemplateForm: true,
          editingForm: true,
          loading: false,
          templateId
        })
      );
      const metadata = {
        plan_name,
        template_id: templateId,
      };
      window.Intercom('trackEvent', 'using-template', metadata);
    }
  };
};

export const getInventoryProducts = async (formId, isPublic = false) => {
  const url = `/api/v2/${isPublic ? 'public' : 'user'}/${Number(formId)}/inventory_product/all`;
  try {
    const { products } = await fplsFetch({ url });
    return products;
  } catch (error) {
    console.log('An error occurred while fetching inventory products', error);
  }
};

export const updateFormInventoryProducts = async (form, formId, isPublic) => {
  if (!form?.definition?.pages) return form;
  let newForm = cloneDeep(form);
  let inventoryFieldData = null;

  newForm.definition.pages.forEach((page, pageIndex) => {
    page.controls.forEach((ctrl, ctrlIndex) => {
      if (ctrl.type === 'inventory_field') {
        inventoryFieldData = {
          pageIndex,
          ctrlIndex,
        };
      }
    });
  });

  if (inventoryFieldData) {
    const products = await getInventoryProducts(formId, isPublic);
    const { pageIndex, ctrlIndex } = inventoryFieldData;
    if (products) {
      newForm.definition.pages[pageIndex].controls[ctrlIndex].props.inventory_products = products;
    }
  }

  return newForm;
};

export const route2SavedForm = (formId) => async (dispatch) => {
  dispatch(fetchFormStart());

  let json = await dispatch(fetchTrueForm(formId));

  if (!json || !json.definition) {
    const error = `An error occurred when retrieving this form. Please refresh and try again or email support@formpl.us if the issue persists.`;
    dispatch(fetchFormFailure({ error, loading: false }));
    return;
  }

  const ctrlIdentifiers = generateBuilderForm(json)?.oldInternalIdentifiers;
  const isInventoryForm = Object.values(ctrlIdentifiers || {}).some(({ type }) => type === ControlType.INVENTORY);

  if (isInventoryForm) {
    json = await updateFormInventoryProducts(json, formId);
  }

  dispatch(doFetchSavedForm(json, false, formId));
};

export const route2NewForm = () => async (dispatch) => {
  const exceeded = await dispatch(checkQuotas());
  if (exceeded) return dispatch(doShowQuotaExceededModal(true));

  const { response: autoSavedResponse, needToConfirm } = await autosave.getSavedResponse(true);
  if (!autoSavedResponse) dispatch(doSetUpNewForm());

  if (needToConfirm) dispatch(updateAutoSave({ status: true, autoSavedResponse }));
};

export const autosaveAction = (restore) => (dispatch, getState) => {
  const { present } = getState().builder;
  const { isNewForm, isTemplateForm, autoSavedResponse } = present;

  if (restore) {
    if (isNewForm) {
      dispatch(updateAutoSave({ status: false }));
      dispatch(doSetUpNewForm(autoSavedResponse));
    } else if (isTemplateForm) {
      dispatch(setupSavedLocalForm(autoSavedResponse));
    }
    return;
  }

  if (isNewForm) {
    dispatch(doSetUpNewForm());
    autosave.saveResponse(present);
  } else {
    dispatch(updateAutoSave({ status: false }));
  }
}; 

export const route2TemplateForm = (templateId) => async (dispatch) => {
  const { response: autoSavedResponse, needToConfirm } = await autosave.getSavedResponse(true, templateId);
  dispatch(fetchFormStart());
  if (autoSavedResponse && needToConfirm) {
    dispatch(doFetchTemplateForm(autoSavedResponse, templateId, true));
  }
  const exceeded = await dispatch(checkQuotas());
  if (exceeded) return;
  const json = await fplsFetch({ url: `/api/v2/public/templates/${templateId}` });
  dispatch(doFetchTemplateForm(json, templateId, false));
};

export const doCheckPaymentCredentials = () => (dispatch) => {
  fplsFetch({ url: '/api/v2/user/credentials' })
    .then((response) =>
      dispatch(
        checkPaymentCredentials({
          stripe_credentials: JSON.parse(response.stripe_credentials),
          flutterwave_credentials: JSON.parse(response.flutterwave_credentials),
          paypal_credentials: JSON.parse(response.paypal_credentials),
          paystack_credentials: JSON.parse(response.paystack_credentials),
        })
      )
    )
    .catch((error) => console.error('Payment Credential Error', error));
};

export const doClearForm = () => (dispatch, getState) => {
  const { builderForm } = getState().builder.present;
  const hasCtrls = formHasControls(builderForm);
  if (hasCtrls) dispatch(doShowFormControlsModal(true));
  else dispatch(clearForm());
};

export const checkCred = (type) => (dispatch, getState) => {
  const { vm, stripe_credentials, flutterwave_credentials, paypal_credentials, paystack_credentials } =
    getState().formValidations;
  const ctrlMap = {
    stripe: stripe_credentials,
    flutterwave: flutterwave_credentials,
    paypal: paypal_credentials,
    paystack: paystack_credentials,
  };
  const credentials = ctrlMap[type];
  const paymentType = `${type.charAt(0).toUpperCase()}${type.substr(1)}`;

  const isCredentialMissing = () => {
    return (
      !credentials ||
      (type === 'stripe' && !credentials.stripe_user_id) ||
      (type === 'flutterwave' && (!credentials.public_key || !credentials.private_key)) ||
      (type === 'paypal' && !(credentials.client_id || credentials.test_client_id)) ||
      (type === 'paystack' && !(credentials.public_key || credentials.test_public_key))
    );
  };

  if (isCredentialMissing() && !vm.missing_credentials.includes(paymentType)) {
    dispatch(
      checkUserVm({
        missing_credentials: [...vm.missing_credentials, paymentType],
        showNag: true,
        authorizePaymentNag: true,
      })
    );
  }
};

export const checkFormHasPaymentField = () => (dispatch, getState) => {
  const {
    builder: {
      present: { builderForm: form },
    },
    formValidations: { vm },
  } = getState();
  const { pages, pageIds } = form;
  const paymentCtrls = [];

  pages.forEach((page, index) => {
    pageIds[index].forEach((id, idx) => {
      const fieldId = pageIds[index][idx];
      const ctrl = pages[index][Number(fieldId)];
      // check for payment fields in form and if they have credentials
      if (vm.fields.includes(ctrl.type)) {
        paymentCtrls.push(ctrl);
        dispatch(checkCred(ctrl.type));
      }
    });
  });

  // disable user specify for payments fields as applicable
  if (paymentCtrls.length > 0) {
    dispatch(disablePaymentUserSpecify(paymentCtrls));
  }
};

const checkPaymentFields = () => (dispatch, getState) => {
  const {
    builder: {
      present: { builderForm },
    },
  } = getState();

  return builderForm.pages.some((page) => {
    return Object.values(page).some((control) => paymentFields.includes(control.type));
  });
};

export const doHandleExternalSave = (formId) => async (dispatch, getState) => {
  const {
    redirectToCustomise: { status },
    isSavedForm,
  } = getState().builder.present;

  dispatch(externalSave({ isSaving: false, newFormId: formId }));
  const { inventory_field } = dispatch(inventoryControls());
  if (!isSavedForm) dispatch(route2SavedForm(formId));
  dispatch(savingForm(false));

  if (inventory_field) {
    const {
      props: { deleted_inventory_product_ids, inventory_products },
      internal_id,
    } = inventory_field;
    const isAnyNewProduct = inventory_products.some(({ id }) => !id);

    if (deleted_inventory_product_ids.length) {
      // Clear deleted inventory product ids to prevent inventory product quota from being deducted falsely.
      // This prevent product quota deductions from leading to negative values.
      dispatch(doSaveCtrl([], internal_id, 'deleted_inventory_product_ids'));
    }

    if (isAnyNewProduct) {
      // Fetch and update inventory products in case user wants to delete a product,
      // their ids will be available for sending to the backend.
      const updatedProducts = await getInventoryProducts(formId);
      if (updatedProducts) dispatch(doSaveCtrl(updatedProducts, internal_id, 'inventory_products'));
    }
  }

  if (status === 'requested') {
    autosave.deleteSavedResponse();
    dispatch(setRedirectToCustomise({ status: 'yes' }));
  }

  if (status === 'no') {
    toast.success(`Your changes have been saved! Click on "Next" button to customise your form.`);
  }
};

const fieldError = 'Incorrect Field Option';
const errorMsgPageMultiple = (pages) =>
  `You seem to have made errors while creating fields. Please look at page ${pages} to correct them. If you keep getting this message please contact support@formpl.us`;
const errorMsgPageOnce = (pages) =>
  `It seems you made errors while creating some fields, please look at page ${pages} to correct them.`;

export const doSuccess = (response, id) => (dispatch, getState) => {
  const {
    builder: {
      present: { builderForm, form },
    },
  } = getState();
  let mixpanelData;
  let fieldIds;
  let formPages;
  let reversed;
  let newFormId;
  let metadata;

  if (response.form_id) {
    newFormId = response.form_id;
    metadata = {
      form_url: `${protocol}//${hostname}:${port}/form/${newFormId}`,
      form_id: newFormId,
      plan_name,
    };

    try {
      mixpanelData = getFormCreatedMetadata(builderForm.pages, builderForm.name, newFormId);
      fieldIds = mixpanelData[1];
      window.mixpanel.track('Created Form', mixpanelData[0]);
      sendFormFieldsMetadata(builderForm, fieldIds);
    } catch (error) {
      console.error('Mixpanel Error', error, error);
    }

    window.Intercom('trackEvent', 'created-form', metadata);
    // Todo:  Integrate mixpanel and intercom into new-builder for nnew forms saving
    // Todo: Ask backend bros for user plan
  } else {
    metadata = {
      form_url: `${protocol}//${hostname}:${port}/form/${id}`,
      form_id: id,
      plan_name,
    };
    // Todo:  Integrate mixpanel and intercom into new-builder for editing forms
    try {
      formPages = compareForm(form.definition, builderForm).pages;
      mixpanelData = getFormCreatedMetadata(formPages, form.name, metadata.form_id);
      fieldIds = mixpanelData[1];

      if (fieldIds.length === 0) {
        reversed = true;
        formPages = compareForm(form.definition, builderForm, reversed).pages;
        mixpanelData = getFormCreatedMetadata(formPages, form.name, metadata.form_id);
        fieldIds = mixpanelData[1];
      }

      window.mixpanel.track('Edited Form', mixpanelData[0]);
      sendFormFieldsMetadata(builderForm, fieldIds, reversed);
    } catch (error) {
      console.error('Mixpanel Error:', error, error);
    }

    window.Intercom('trackEvent', 'edited-form', metadata);
  }

  dispatch(doHandleExternalSave(response.form_id ?? id));
};

export const showMarshalError = (marshalErrors, fullForm) => (dispatch, getState) => {
  const { internalIdentifiers } = getState().builder.present;
  if (!marshalErrors.length) return;
  let errShownCount = 0;
  const highlighted = new Set();
  let errorPages = new Set();
  const errorCtrls = [];
  const errorMsgFields = (pags) => (errShownCount ? errorMsgPageMultiple(pags) : errorMsgPageOnce(pags));
  const backendForm = fullForm.definition;
  dispatch(disableHandler());
  for (let i = 0; i < marshalErrors.length; i += 1) {
    const [pageIndex, ctrlIndex] = marshalErrors[i].match(/\d{1,}/g);

    if (ctrlIndex) {
      const errPage = backendForm.pages[pageIndex];
      let errCtrl = errPage.controls[ctrlIndex];
      const { internal_id } = errCtrl;
      if (highlighted.has(internal_id)) continue;
      // Todo replace with internalIdentifiers
      errCtrl = internalIdentifiers[internal_id];
      errCtrl._validationError = fieldError;
      highlighted.add(internal_id);
      errorPages.add(Number(pageIndex) + 1);
      errorCtrls.push(errCtrl);
    }
  }
  errorPages = [...errorPages];
  errorPages = errorPages.join(', Page ');

  const errors = errorMsgFields(errorPages);
  dispatch(showFormError({ formError: errors }));
  errShownCount += 1;
};

export const doError = (error, fullForm) => (dispatch, getState) => {
  const { form } = getState().builder.present;

  console.error(`Error while saving form (id: ${form?.id ?? '__NEW__'}). Details:`, error);
  
  dispatch(savingForm(false));
  
  const genericMsg =
    '[#6] An error has occurred while saving your ' +
    'form. Please chat with us or contact support@formpl.us ' +
    'about this error';

  const errorMsg = error.data?.message;
  let marshalErrors = error.data?.errors;
  if (!marshalErrors) {
    const errorText = errorMsg || genericMsg;
    dispatch(showFormError({ formError: errorText }));
  }
  try {
    marshalErrors = Object.keys(marshalErrors);
  } catch {
    marshalErrors = [];
  }
  showMarshalError(marshalErrors, fullForm);
};

const validateNumberCtrl = (props, colIdx = null) => {
  const count = (n) => (n ? String(Math.abs(n)).length : n); // get number character count

  const setError = (error) => `${error} ${colIdx ? `(Check column ${colIdx})` : ''}`;

  if (props.min_count && props.max_count) {
    if (props.min_count > props.max_count) {
      return setError(ctrlErrors.min_count_greater_than_max);
    }
  }

  if (props.min_acceptable && props.max_acceptable) {
    if (props.min_acceptable > props.max_acceptable) {
      return setError(ctrlErrors.min_acceptable_greater_than_max);
    }

    // if (props.min_acceptable === props.max_acceptable) {
    //    return setError(ctrlErrors.min_acceptable_equals_max);
    // }
  }

  if (props.min_acceptable && props.min_count) {
    if (count(props.min_acceptable) < props.min_count) {
      return setError(ctrlErrors.min_acceptable_less_than_min_count);
    }
  }

  if (props.max_acceptable && props.min_count) {
    if (count(props.max_acceptable) < props.min_count) {
      return setError(ctrlErrors.max_acceptable_less_than_min_count);
    }
  }

  if (props.min_acceptable && props.max_count) {
    if (count(props.min_acceptable) > props.max_count) {
      return setError(ctrlErrors.min_acceptable_greater_than_max_count);
    }
  }

  if (props.max_acceptable && props.max_count) {
    if (count(props.max_acceptable) > props.max_count) {
      return setError(ctrlErrors.max_acceptable_greater_than_max_count);
    }
  }
};

export const validateCtrl = (ctrl) => (dispatch, getState) => {
  if (!ctrl) return null;

  const state = getState();
  const { userOptions } = state.builder.present;
  const { admin_unflagged = false } = userOptions || {};
  const { vm } = state.formValidations;

  const { props, type } = ctrl;
  const {
    accept_inventory_payment,
    inventory_payment_type,
    default: defaultValue,
    address_fields_order,
    phone_valid_codes,
    phone_codes_limit,
    source_field_ids,
    show_row_headers,
    max_word_length,
    min_word_length,
    max_selections,
    min_selections,
    column_headers,
    dest_field_ids,
    option_values,
    column_types,
    lookup_type,
    row_headers,
    table_props,
    min_length,
    form_field,
    max_length,
    controls,
    min_rows,
    min_date,
    max_date,
    min_time,
    max_time,
    max_rows,
    required,
    currency,
    weights,
    options,
    amount,
    rename,
    text,
    form,
    url,
  } = props;

  const isNumberCtrl =
    type === ControlType.NUMBER ||
    (textFieldsWithType.includes(type) && props.type === InputType.NUMBER);

  // Number default value validation
  if (defaultValue && isNumberCtrl && isNaN(Number(defaultValue))) {
    return ctrlErrors.invalid_number_default;
  }

  // Min/max length validation
  if (min_length && max_length && min_length > max_length) {
    return ctrlErrors.min_greater_than_max_length;
  }

  // Selection validations
  if (min_selections || max_selections) {
    const totalOptions = props.other ? options.length + 1 : options.length;

    if (min_selections > totalOptions) return ctrlErrors.min_greater_than_total_options;
    if (max_selections > totalOptions) return ctrlErrors.max_greater_than_total_options;
  }

  if (min_selections && max_selections && min_selections > max_selections) {
    return ctrlErrors.min_greater_than_max_selection;
  }

  // Word length validation
  if (min_word_length && max_word_length && min_word_length > max_word_length) {
    return ctrlErrors.min_greater_than_max_word;
  }

  // Phone validation
  if (phone_codes_limit && Array.isArray(phone_valid_codes) && phone_valid_codes.length === 0) {
    return ctrlErrors.phone_code_required;
  }

  // Options validations
  if (Array.isArray(options)) {
    if (options.length === 0) return ctrlErrors.no_options_provided;

    if (weights && option_values) {
      if (type !== ControlType.SCALE_RATING) {
        if (weights.length === 0) return ctrlErrors.no_option_values;
      } else if (options.length > 2) {
        return ctrlErrors.two_many_options;
      }
    }
  }

  // Number control validation
  if (isNumberCtrl) {
    const numberError = validateNumberCtrl(props);
    if (numberError) return numberError;
  }

  // Embed validation
  if (type === ControlType.EMBED_FIELD) {
    const trimmedUrl = url?.trim();
    if (!trimmedUrl) return ctrlErrors.invalid_url_empty;
    if (!urlTestPattern.test(trimmedUrl)) return ctrlErrors.invalid_url_format;

    const allowedURLsRegex = /^(https:\/\/)?(www\.)?(youtube.com\/watch\?v|vimeo\.com|cincopa\.com)/;
    if (!allowedURLsRegex.test(trimmedUrl)) return ctrlErrors.invalid_url_domain;
  }

  // Matrix rating validation
  if (type === ControlType.MATRIX_RATING) {
    if (!row_headers?.length) return ctrlErrors.blank_headers;

    const validateHeaders = (headers) => {
      const hasUnallowed = hasLiteralNullOrUndefined(headers);
      const hasSimilar = hasDuplicateString(headers);
      const hasBlank = hasEmptyString(headers);

      if (hasUnallowed) return ctrlErrors.unallowed_headers;
      if (hasSimilar) return ctrlErrors.duplicate_headers;
      if (hasBlank) return ctrlErrors.blank_headers;

      return null;
    };

    if (column_headers?.length) {
      const colError = validateHeaders(column_headers);
      if (colError) return colError;
    }

    if (row_headers?.length) {
      const rowError = validateHeaders(row_headers);
      if (rowError) return rowError;
    }

    if (column_headers?.length > 15) return ctrlErrors.too_many_column_headers;
    if (row_headers?.length > 15) return ctrlErrors.too_many_row_headers;
  }

  // Image choice validation
  if (type === ControlType.IMAGE_CHOICE) {
    if (!options?.length) return ctrlErrors.no_image_options;
    if (hasEmptyString(options)) return ctrlErrors.missing_image_labels;
  }

  // Payment validation
  if (vm.fields.includes(type)) {
    if (amount <= 0) return ctrlErrors.amount_must_be_positive;

    if (required) {
      checkCred(type);
      const paymentType = `${type.charAt(0).toUpperCase()}${type.substr(1)}`;
      if (vm.missing_credentials.includes(paymentType)) {
        return `${paymentType} ${ctrlErrors.payment_field_requires_credentials}`;
      }
    }
  }

  // PayPal decimal restriction
  const nonDecimals = ['TWD', 'JPY', 'HUF'];
  const decimalRegex = /^\d+\.\d+$/;
  if (
    type === ControlType.PAYPAL &&
    nonDecimals.includes(currency) &&
    decimalRegex.test(String(amount))
  ) {
    return `${ctrlErrors.unsupported_decimal_currency} ${currency} ${ctrlErrors.paypal_decimal_error}`;
  }

  // Description validation
  if (type === ControlType.DESCRIPTION) {
    if (text?.replace(/\s/g, '').includes('<script>')) return ctrlErrors.invalid_description;
    if (isInvalidEditorMsg(text, admin_unflagged)) return ctrlErrors.invalid_description;
  }

  // Lookup validation
  if (type === ControlType.LOOKUP) {
    if (source_field_ids && dest_field_ids) {
      const hasSimilarSrc = hasDuplicateString(source_field_ids);
      const hasSimilarDest = hasDuplicateString(dest_field_ids);

      if (hasSimilarDest || hasSimilarSrc) return ctrlErrors.duplicate_field_mapping;
      if (source_field_ids.length !== dest_field_ids.length) {
        return ctrlErrors.unequal_source_destination_mapping;
      }

      const invalidLookup =
        !form ||
        !form_field ||
        (lookup_type == 1 &&
          (!source_field_ids?.length ||
            !dest_field_ids?.length ||
            source_field_ids[0]?.startsWith('init') ||
            dest_field_ids[0]?.startsWith('init')));

      if (invalidLookup) return ctrlErrors.invalid_lookup;
    }
  }

  // Date validation
  if (min_date && max_date && new Date(min_date) > new Date(max_date)) {
    return ctrlErrors.min_date_greater_than_max;
  }

  // Time validation
  if (min_time && max_time) {
    const [minHour, minMinute] = min_time.split(':').map(Number);
    const [maxHour, maxMinute] = max_time.split(':').map(Number);

    if (minHour > maxHour || (minHour === maxHour && minMinute > maxMinute)) {
      return ctrlErrors.min_time_greater_than_max;
    }
  }

  // File upload validation
  if (type === ControlType.FILE_UPLOAD && rename?.enabled && !rename.internal_id) {
    return ctrlErrors.missing_rename_internal_id;
  }

  // Row validation
  if (type === ControlType.ROW && !controls?.length) {
    return ctrlErrors.min_row_fields;
  }

  // Table validation
  if (type === ControlType.TABLE_FIELD) {
    const hasBlankCols = hasEmptyString(column_headers);
    const hasBlankRows = hasEmptyString(row_headers);

    if (hasBlankCols || (show_row_headers && hasBlankRows)) {
      return ctrlErrors.blank_headers;
    }

    if (min_rows < 1) return ctrlErrors.min_row_below_limit;
    if (max_rows < 1) return ctrlErrors.res_row_below_limit;
    if (min_rows > 50) return ctrlErrors.min_row_above_limit;
    if (max_rows > 50) return ctrlErrors.res_row_above_limit;

    if (Array.isArray(table_props)) {
      for (let i = 0; i < table_props.length; i++) {
        const tableProp = table_props[i];

        if (column_types.includes('text_input')) {
          if (
            tableProp.min_length &&
            tableProp.max_length &&
            tableProp.min_length > tableProp.max_length
          ) {
            return `${ctrlErrors.min_greater_than_max_length} (Check column ${i + 1})`;
          }
        }

        if (column_types.includes('number_input')) {
          const numberError = validateNumberCtrl(tableProp, i + 1);
          if (numberError) return numberError;
        }
      }
    }
  }

  // Inventory validation
  if (type === ControlType.INVENTORY) {
    if (accept_inventory_payment && !inventory_payment_type) {
      return ctrlErrors.payment_merchant_is_required;
    }
  }

  // Address validation
  if (type === ControlType.ADDRESS) {
    const fieldsOrder =
      address_fields_order ?? elements[ControlType.ADDRESS].address_fields_order;

    let atLeastOneField = false;

    for (const [index, field] of fieldsOrder.entries()) {
      const fieldProps = props[field];
      if (fieldProps?.display) atLeastOneField = true;
      if (!fieldProps?.label) {
        return `Label for secondary address field (${index + 1}) is required`;
      }
    }

    if (!atLeastOneField) return ctrlErrors.empty_address_fields;
  }

  return null;
}

export const validateFormFields = () => (dispatch, getState) => {
  const { builderForm: form } = getState().builder.present;
  const newForm = cloneDeep(form);

  const { pages, pageIds } = newForm;
  const errorPages = new Set();
  const errorCtrls = [];
  const errorIds = [];
  let errShownCount = 0;

  const errorMsgFields = (pagesStr) => (errShownCount ? errorMsgPageMultiple(pagesStr) : errorMsgPageOnce(pagesStr));

  dispatch(disableHandler());

  newForm.name = htmlToPlainText(form.name);

  pages.forEach((page, pageIndex) => {
    pageIds[pageIndex].forEach((fieldId) => {
      const ctrl = page[fieldId];
      const validationError = dispatch(validateCtrl(ctrl));
      if (validationError) {
        ctrl._validationError = validationError;
        errorPages.add(pageIndex + 1);
        errorCtrls.push(ctrl);
        errorIds.push(ctrl.internal_id);
        dispatch(showFieldError({ ctrl, index: pageIndex }));
      }
    });
  });

  const noErrors = errorIds.length === 0;
  errShownCount += 1;

  const errorPageList = [...errorPages].join(', Page ');

  return [noErrors, errorMsgFields(errorPageList)];
};

function getUnsupportedFields(form, remove) {
  const restrictedFields = ['pages', 'name'];
  const unsupportedFields = [];

  for (const field of Object.keys(form)) {
    if (!restrictedFields.includes(field)) {
      const isSupported = planSupportField(field);
      if (!isSupported && form[field].length > 0) {
        if (remove) form[field] = [];
        else unsupportedFields.push(field);
      }
    }
  }

  return unsupportedFields;
}

function getUnsupportedPageControls(pages, remove) {
  let unsupportedControls = [];

  for (const page of pages) {
    const unsupportedIndexes = page.controls.reduce((acc, control, idx) => {
      if (!planSupportField(control.type)) acc.push(idx);
      return acc;
    }, []);

    if (remove) {
      page.controls = page.controls.filter((_, idx) => !unsupportedIndexes.includes(idx));
    }

    unsupportedControls = unsupportedControls.concat(unsupportedIndexes);
  }

  return unsupportedControls;
}

export const processPremiumControls =
  (remove = false, form = null) =>
  (dispatch, getState) => {
    const { builderForm } = getState().builder.present;
    const fullForm = form || ammendBuilderForm(builderForm);
    const premiumKeys = getUnsupportedFields(fullForm, remove);
    const premiumControlIndexes = getUnsupportedPageControls(fullForm.pages, remove);

    const isPremium = premiumKeys.length > 0 || premiumControlIndexes.length > 0;
    dispatch(updateCredential({ isPremium }));

    return fullForm;
  };

export const presendParsing = (form, autosave) => (dispatch, getState) => {
  const { form: oldForm, builderForm, addRowCtrls } = getState().builder.present;
  const tempForm = cloneDeep(form);
  const allLookupForms = [];
  const copiedaddRowControls = cloneDeep(addRowCtrls);
  for (let r = 0; r < tempForm.definition.pages.length; r += 1) {
    tempForm.definition.pages[r].controls = pageReorderControl(tempForm.definition.pages[r], copiedaddRowControls);
  }
  // clear phone codes and set default labels
  for (let p = 0; p < tempForm.definition.pages.length; p += 1) {
    for (let c = 0; c < tempForm.definition.pages[p].controls.length; c += 1) {
      const ctrl = form.definition.pages[p].controls[c];

      if (!ctrl) continue;

      ctrl.props.label = ctrl.props.label || ctrlDefaults()[ctrl.type];
      if (ctrl.phoneCodes) {
        delete ctrl.phoneCodes;
      }

      if (
        ctrl.type === 'select_basic' ||
        ctrl.type === 'select_multiple' ||
        ctrl.type === 'matrix_rating' ||
        ctrl.type === 'table_field' ||
        ctrl.type === 'image_choice' ||
        ctrl.type === 'lookup'
      ) {
        ctrl.value = null;
      }

      if (ctrl.props.phone_valid_codes) {
        for (let i = 0; i < ctrl.props.phone_valid_codes.length; i += 1) {
          if (ctrl.props.phone_valid_codes[i].code) {
            ctrl.props.phone_valid_codes[i] = ctrl.props.phone_valid_codes[i].code;
          } else {
            // ctrl.props.phone_valid_codes[i] = ctrl.props.phone_valid_codes[i]
          }
        }
      }

      if (ctrl.type === 'lookup' && oldForm) {
        const lookupDetails = {
          form_with_lookup_field: oldForm.id,
          form_to_lookup_from: ctrl.props.form,
          field_to_lookup: ctrl.props.form_field,
          lookup_form_name: oldForm.name,
        };
        allLookupForms.push(lookupDetails);
      }

      if (!ctrl.internal_id) ctrl.internal_id = newIdentifier(Object.keys(builderForm.identifiers));
      if (!ctrl.display_id) ctrl.display_id = ctrl.internal_id;
    }
  }

  tempForm.lookupForms = allLookupForms;
  if (autosave) return tempForm;
  for (let q = tempForm.definition.pages.length - 1; q >= 0; q -= 1) {
    if (tempForm.definition.pages[q].controls.length === 0) {
      tempForm.definition.pages.splice(q, 1);
    }
  }
  tempForm.definition = dispatch(processPremiumControls(true, tempForm.definition));

  return tempForm;
};

const validateTimerAndPaymentConstraints = () => async (dispatch, getState) => {
  const { isTemplateForm, enableTimer, isNewForm, form } = getState().builder.present;
  if (isTemplateForm || isNewForm || !form?.id) return false;

  const hasPaymentField = await dispatch(checkPaymentFields());
  if (!enableTimer && !hasPaymentField) return false;

  const trueForm = await dispatch(fetchTrueForm(form.id));
  const isSubmitHidden = trueForm?.options?.hide_submit_button;
  if (!isSubmitHidden) return false;

  const message =
    enableTimer && hasPaymentField
      ? 'Timer and payment fields cannot be added when the submit button is disabled'
      : enableTimer
      ? 'Timer cannot be added when the submit button is disabled'
      : 'Payment fields cannot be added when the submit button is disabled';

  toast.error(message);
  return true;
};

export const internalSaveForm = (isNewForm) => async (dispatch, getState) => {
  const {
    enableClosingPage,
    enableESignature,
    enableIntroPage,
    timerOptions,
    closingPages,
    introDetails,
    builderForm,
    enableTimer,
    templateId,
    form,
  } = getState().builder.present;

  const formMetaData = {};

  if (!formHasControls(builderForm)) {
    dispatch(
      showFormError({
        formError: `You can't save an empty form. Please add some form fields to your form and then save.`,
      })
    );
    return;
  }

  const hasTimerAndPaymentConstraints = await dispatch(validateTimerAndPaymentConstraints());
  if (hasTimerAndPaymentConstraints) return;

  dispatch(savingForm(true));
  const invalidForm = dispatch(validateFormFields());

  if (!invalidForm[0]) {
    dispatch(showFormError({ formError: invalidForm[1] }));
    dispatch(savingForm(false));
    return;
  }

  const newForm = ammendBuilderForm(builderForm);
  const { formJ, metaData } = checkWideForm(newForm, formMetaData);
  const storableClosingPages = convertToStorableClosingPages(closingPages);

  const options = {
    enable_closing_page: enableClosingPage,
    enable_esignature: enableESignature,
    enable_intro_page: enableIntroPage,
    timer_options: timerOptions,
    enable_timer: enableTimer,
  };

  let fullForm = {
    description: builderForm.description,
    closing_pages: storableClosingPages,
    definition: formJ,
    ...introDetails,
    options,
    ...(isNewForm && {
      origin_form_id: form?.id || null,
      origin_template_form_id: null,
      origin_templatemodel_id: null,
      metadata: metaData,
      id: '_NEW_',
    }),
  };

  fullForm = dispatch(presendParsing(fullForm));

  const handleErrorResponse = (response) => {
    dispatch(savingForm(false));
    dispatch(showBuilderError(`${response.error} please contact support.`));
    console.error(response.error);

    if (response.status === '403' && response.error.includes('form is inactive')) {
      dispatch(indicateFormDeactivation(true));
    }

    const knownErrorMessages = ['You cannot create more forms than your plan allows'];

    const defaultErrorMessage = `There was is an issue with saving this form. please contact support.`;
    const knownErrorMessage = knownErrorMessages.find((msg) => response.error.includes(msg));
    const errorMessage = knownErrorMessage || defaultErrorMessage;
    toast.error(errorMessage);
  };

  const method = isNewForm ? 'POST' : 'PUT';
  const url = isNewForm ? '/api/v2/user/form' : `/api/v2/user/form/${form.id}`;

  const data = isNewForm ? apiCommon({ form: fullForm }) : apiCommon({ form_id: form.id, form: fullForm });
  
  if (templateId) data.template_id = templateId;
  
  fplsFetch({ method, url, data })
    .then((response) => {
      if (response.error) return handleErrorResponse(response);
      dispatch(doSuccess(response, isNewForm ? undefined : form.id));
      dispatch(setIsBuilderFormUpdated(false));
    })
    .catch((err) => dispatch(doError(err, fullForm)));
};

export const showPaymentNag = (isNewForm) => async (dispatch, getState) => {
  await dispatch(checkFormHasPaymentField());
  dispatch(saveAction({ create: isNewForm }));

  const { showNag } = getState().formValidations.vm;

  if (showNag) {
    dispatch(paymentCredentialMissingModal(true));
    return;
  }

  dispatch(internalSaveForm(isNewForm));
};

export const removePremium = (isNewForm) => (dispatch, getState) => {
  const { isPremium, plan } = getState().formValidations;

  dispatch(processPremiumControls());
  dispatch(saveAction({ create: isNewForm }));

  if (plan.trial_eligible && isPremium) {
    dispatch(showClearPremiumModal(true));
  }
};

export const resolvePremiumAccess = (isNewForm) => async (dispatch, getState) => {
  const { isPremium, plan } = getState().formValidations;
  const userId = USER_ID;

  dispatch(removePremium(isNewForm));

  if (isPremium && plan.is_free) {
    if (plan.trial_eligible) {
      try {
        const response = await fplsFetch({
          method: 'PUT',
          url: `/api/v2/user/${userId}/upgrade_to_trial`,
        });
        dispatch(updatePlan(response.plan));
        dispatch(showPaymentNag(isNewForm));
      } catch (error) {
        console.error('Upgrade Free plan error', error);
        dispatch(
          showFormError({
            formError: 'Upgrade Free plan error',
          })
        );
      }
    } else {
      dispatch(
        showFormError({
          formError: 'Cannot use template with premium fields. Please upgrade.',
        })
      );
    }
  } else {
    dispatch(showPaymentNag(isNewForm));
  }
};

export const doSaveForm = (isNewForm) => (dispatch, getState) => {
  const { builderForm } = getState().builder.present;

  const formName = builderForm.name;
  const isEmptyName = typeof formName !== 'string' || /^\s*$/.test(formName);

  if (isEmptyName) {
    dispatch(doShowFormNameModal(true));
    return;
  }

  dispatch(resolvePremiumAccess(isNewForm));
};

export const doFetchPDFForm = () => async (dispatch) => {
  const form = getPDFForm();
  const error = 'Failed to fetch PDF form. Please try again.';
  if (!form) {
    dispatch(showFormError({ formError: error }));
    return;
  }
  const { undoReducers } = form;
  const { present } = undoReducers;
  const { elementIds, elements } = present.element.pageElements;
  const pdfElementCtrls = [];
  const propsTypeArray = ['short_text', 'labeled_input', 'datetime', 'text_input'];

  for (let e = 0; e < elementIds.length; e += 1) {
    const elementId = elementIds[e];
    const elementCtrl = elements[elementId];
    if (elementCtrl.type === 'datetime' && !elementCtrl.props?.time_section) {
      elementCtrl.props.type = 1;
    } else if (propsTypeArray.includes(elementCtrl.type)) {
      elementCtrl.props.type = 0;
    }
    if (
      elementCtrl.props.time_section === true &&
      !(elementCtrl.props.day_section && elementCtrl.props.month_section && elementCtrl.props.year_section)
    ) {
      elementCtrl.props.type = 2;
    }
    if (elementCtrl.type === 'signature') {
      elementCtrl.props.rename = { enabled: false, internal_id: '' };
      elementCtrl.props.hidden = false;
    }

    let filename = '';
    let gcsUrl = '';
    if (elementCtrl.type === 'media_image') {
      const dataUrl = elementCtrl.props.upload_image;
      if (dataUrl) {
        filename = `${elementCtrl.internal_id}.png`;
        try {
          gcsUrl = localStorage.getItem(filename) || '';
        } catch (err) {
          console.error('Gettng PDF image name from Localstorage Error', err);
        }
        if (!gcsUrl) {
          gcsUrl = await uploadPDFImgToServer(dataUrl, filename);
        }
        elementCtrl.props.upload_image = gcsUrl;
      }
    } else if (elementCtrl.type === 'image_choice') {
      const dataUrls = elementCtrl.props.images;
      for (let u = 0; u < dataUrls.length; u++) {
        const url = dataUrls[u];
        if (url) {
          filename = `${elementCtrl.internal_id}_${u}.png`;
          try {
            gcsUrl = localStorage.getItem(filename) || '';
          } catch (err) {
            console.error('Getting PDF image name from Localstorage Error', err);
          }
          if (!gcsUrl) {
            gcsUrl = await uploadPDFImgToServer(url, filename);
          }
          dataUrls[u] = gcsUrl;
        }
      }
    } else if (elementCtrl.type === 'table_field') {
      const types = elementCtrl.props.column_types;
      for (let t = 0; t < types.length; t++) {
        const type = types[t];
        if (type === 'datetime') {
          const tableProp = elementCtrl.table_props[t];
          if (!tableProp.hasOwnProperty('default')) {
            tableProp.default = '';
          }
          if (!tableProp.hasOwnProperty('label')) {
            tableProp.label = 'Date and Time';
          }
          if (!tableProp.hasOwnProperty('hidden')) {
            tableProp.hidden = false;
          }
          if (!tableProp.hasOwnProperty('readonly')) {
            tableProp.readonly = false;
          }
          if (!tableProp.hasOwnProperty('separator')) {
            tableProp.separator = '/';
          }
          if (!tableProp.hasOwnProperty('type')) {
            tableProp.type = 0;
          }
        }
      }
    } else if (elementCtrl.type === 'add_row') {
      elementCtrl.is_row = false;
      const controls = cloneDeep(elementCtrl.props.controls);
      for (let c = 0; c < controls.length; c++) {
        const ctrl = controls[c];
        elementCtrl.props.controls[c] = ctrl.internal_id;
        ctrl.is_row = true;
        pdfElementCtrls.push(ctrl);
      }
    }
    pdfElementCtrls.push(elementCtrl);
  }
  const formData = {
    name: present?.element?.pageInfo?.pdfName,
    definition: {
      calculations: [],
      rules: [],
      pages: [
        {
          controls: pdfElementCtrls,
          internal_id: newIdentifier(present?.element?.pageElements?.elementIds),
        },
      ],
    },
  };
  dispatch(fetchPDFSuccess(formData));
};

export const route2PDFForm = () => async (dispatch) => {
  const exceeded = await dispatch(checkQuotas());
  if (exceeded) return;
  dispatch(doFetchPDFForm());
};
